import React from 'react';
import { CheckCircle, Clock, XCircle } from 'lucide-react';

// Status config: maps status key → display label, colors, icon
const STATUS_CONFIG = {
  approved: {
    label: 'Đã duyệt',
    bgClass: 'bg-green-100',
    textClass: 'text-green-700',
    borderClass: 'border-green-200',
    Icon: CheckCircle,
  },
  pending: {
    label: 'Chờ Duyệt',
    bgClass: 'bg-yellow-100',
    textClass: 'text-yellow-700',
    borderClass: 'border-yellow-200',
    Icon: Clock,
  },
  rejected: {
    label: 'Từ chối',
    bgClass: 'bg-red-100',
    textClass: 'text-red-700',
    borderClass: 'border-red-200',
    Icon: XCircle,
  },
};

/**
 * ApprovalStatusBadge - Small rounded badge for "Cty duyệt?" status.
 *
 * Props:
 *   status {string} - 'approved' | 'pending' | 'rejected'
 */
const ApprovalStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const { label, bgClass, textClass, borderClass, Icon } = config;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${bgClass} ${textClass} ${borderClass}`}
    >
      <Icon size={12} className="flex-shrink-0" />
      {label}
    </span>
  );
};

export default ApprovalStatusBadge;
